import { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { LanguageContext } from './contexts/LanguageContext';

// FIX: Add proper fallback chain
const getBrowserLanguage = () => {
  try {
    const navLang = navigator.language || navigator.userLanguage || 'en';
    return navLang.split(/[-_]/)[0];
  } catch (e) {
    return 'en'; // Ultimate fallback
  }
};

const local = getBrowserLanguage();

const langFiles = {
  en: '/lang/en.json?t=' + new Date().getTime(),
  fr: '/lang/fr.json?t=' + new Date().getTime(),
  de: '/lang/de.json?t=' + new Date().getTime(),
  it: '/lang/it.json?t=' + new Date().getTime(),
  es: '/lang/es.json?t=' + new Date().getTime(),
  ja: '/lang/ja.json?t=' + new Date().getTime(),
  zh: '/lang/zh.json?t=' + new Date().getTime(),
  'zh-TW': '/lang/zh-TW.json?t=' + new Date().getTime(),
};

const WrapperIntl = (props) => {
  // Bulletproof: Always prefer sessionStorage, log all changes
  const getInitialLocale = () => {
    const sessionLang = sessionStorage.getItem('language');
    const supportedLangs = Object.keys(langFiles);
    if (sessionLang && supportedLangs.includes(sessionLang)) {
      console.log('[WrapperIntl] Using session language:', sessionLang);
      return sessionLang;
    }
    const browserLang = local;
    if (supportedLangs.includes(browserLang)) {
      console.log('[WrapperIntl] Using browser language:', browserLang);
      return browserLang;
    }
    console.log('[WrapperIntl] Falling back to en');
    return 'en';
  };

  const [locale, setLocale] = useState(getInitialLocale());
  const [messages, setMessages] = useState({});

  useEffect(() => {
    // Always sync sessionStorage to current locale
    if (sessionStorage.getItem('language') !== locale) {
      sessionStorage.setItem('language', locale);
      console.log('[WrapperIntl] Synced sessionStorage to locale:', locale);
    }
    const langFile = langFiles[locale] || langFiles.en;
    console.log('[WrapperIntl] Fetching language file:', langFile);
    fetch(langFile)
      .then(res => res.json())
      .then(msgs => {
        setMessages(msgs);
        console.log('[WrapperIntl] Loaded messages for', locale);
      })
      .catch(err => {
        console.error('[WrapperIntl] Failed to load language file:', err);
        // Fallback to English if language file fails to load
        if (locale !== 'en') {
          fetch(langFiles.en)
            .then(res => res.json())
            .then(setMessages);
        }
      });
  }, [locale]);

  function selectLanguage(value) {
    if (Object.keys(langFiles).includes(value)) {
      console.log('[WrapperIntl] selectLanguage called with:', value);
      setLocale(value);
      sessionStorage.setItem('language', value);
    } else {
      console.warn('[WrapperIntl] Attempted to select unsupported language:', value);
    }
  }

  return (
    <LanguageContext.Provider value={{ locale, selectLanguage }}>
      {Object.keys(messages).length > 0 ? (
        <IntlProvider messages={messages} locale={locale}>
          {props.children}
        </IntlProvider>
      ) : null}
    </LanguageContext.Provider>
  );
};

export default WrapperIntl;